export default "__VITE_ASSET__DzwAvst$__"